module.exports = __webpack_public_path__ + "img/campaign.9b871a86.svg";